var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.kudos
    ? _c(
        "div",
        {
          staticClass: "mt-0 mt-lg-0 h-100 d-flex flex-column overflow-hidden"
        },
        [
          _c(
            "div",
            { staticClass: "col-12 h-100 d-flex flex-column p-0 m-0" },
            [
              _c("h3", [_vm._v(_vm._s(_vm.title ? _vm.title : "Kudos!"))]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "w-100 mb-0 scroll-panel mt-3 mt-lg-3" },
                [
                  _vm.kudos.length > 0
                    ? _c(
                        "div",
                        _vm._l(_vm.kudos, function(kudo) {
                          return kudo.comment
                            ? _c(
                                "div",
                                {
                                  staticClass: "kudos-message",
                                  attrs: { for: kudo.id }
                                },
                                [
                                  _c("div", {
                                    staticClass: "message",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.formatKudo(kudo.comment)
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  kudo.admin_response
                                    ? _c("div", {
                                        staticClass: "message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.formatKudo(kudo.admin_response)
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "timestamp" }, [
                                    _vm._v(_vm._s(kudo.ts))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" })
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "col-12 card container text-left p-0 mb-4 no-surveys"
                        },
                        [_vm._m(0)]
                      )
                ]
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body text-center" }, [
      _c("h5", { staticClass: "text-center w-100 p-0 m-0" }, [
        _vm._v("You don't seem to have any Kudos at the moment")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61c116c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c116c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kudos.vue
// module id = null
// module chunks = 